import baseURL from "../config/api";
import axios from "../config/axios";

export const post_Course = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}courses?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_EnrollCourse = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}enrolledCourses?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_Course = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}courses?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_CourseCategory = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}courseCategories?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const delete_Course = (primaryKey: number, userId:number) => {
    return axios({
        url: `${baseURL}courses?id=${primaryKey}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}

export const getCourseCategoriesWithPublishCourses = () => {
    return getFetch("courseCategories/GetCourseCategoriesWithPublishCourses")
}

export const getPublishCourses = (isPublished: boolean) => {
    return getFetch(`courses/GetPublishedCourses/${isPublished}`)
}

export const getEnrolledCourses = (userId:number) => {
    return getFetch(`courses/GetEnrolledCoursesByUserId/${userId}`)
}

export const getCourseByUser = (userId:number, isPublished: boolean) => {
    return getFetch(`courses/GetCoursesReportByUserIdAndByPublished/${userId},${isPublished}`)
}

export const getCourseCategories = () => {
    return getFetch("courseCategories")
}

export const delete_CourseCategory = (primaryKey: number, userId:number) => {
    return axios({
        url: `${baseURL}courseCategories?id=${primaryKey}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}


const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}